import React, {useEffect, useState}from 'react'
import { defer, LoaderFunction, Outlet} from 'react-router-dom'
import MpHeader from '../shared/organism/MpHeader'
import { getPreferredMfa, MFAEnabled } from '@meprism/shared/src/redux/authentication/authenticationSlice'
import { useAppSelector} from '../../redux/storeExports'
import {store} from '../../redux/store'
import MFARequiredModal from '../shared/molecule/MFARequiredModal'
export const mainLayoutLoader: LoaderFunction = async () => {
  const MFA = store.dispatch(getPreferredMfa()).unwrap()
  return defer({MFA})
}

export const MainLayout = () => {
  const isMFAEnabled = useAppSelector(MFAEnabled)
  const [MFAModalFlag, setMFAModalFlag] = useState(true)
  
  useEffect(()=>{
     setMFAModalFlag(isMFAEnabled)
    }, [isMFAEnabled])
  
  return (
    <>
      <MFARequiredModal open={!MFAModalFlag} setOpen={setMFAModalFlag}/>
      <MpHeader />
      <Outlet />
    </>
  )
}
